import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteEstadoDePagoExterno,
  getEstadosDePagosExternos,
  patchEstadoDePagoExterno,
  postEstadoDePagoExterno,
} from 'api/catalogos/estadosDePagosExternos';

export const permissionConfig = {
  permissionModel: 'estadodepagosexternos',
};

// eslint-disable-next-line react/prop-types
const EstadosDePagosExternos = ({ permission }) => (
  <PlainCRUD
    title="Estados de Pagos Externos"
    permission={permission}
    get={getEstadosDePagosExternos}
    post={postEstadoDePagoExterno}
    patch={patchEstadoDePagoExterno}
    delete={deleteEstadoDePagoExterno}
    fields={[
      defaultFields.descripcion,
      {
        name: 'finalizado',
        label: '¿Finalizado?',
        colWidth: 200,
        type: 'select',
      },
      {
        name: 'observaciones',
        label: 'Observaciones',
        colWidth: 400,
        type: 'textarea',
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default EstadosDePagosExternos;
